module.exports = __webpack_public_path__ + "img/60.66c74e8f.png";